import { createSlice } from '@reduxjs/toolkit';

export type ChatBotState = {
  chatIsOpen: boolean;
}
const initialState: ChatBotState = {
  chatIsOpen: false,
};

const chatBotSlice = createSlice({
  initialState,
  name: 'chatBot',
  reducers: {
    setChatOpen: (state) => {
      state.chatIsOpen = false;
    },
    setChatClosed: (state) => {
      state.chatIsOpen = true;
    },
  }
});

const { actions, reducer } = chatBotSlice;

export const { setChatOpen, setChatClosed } = actions;

export default reducer;
